@if (currentMessages()) {
  @for (message of currentMessages(); track message.id; let index = $index) {
    <div class="text-base" [attr.data-message-id]="message.id">
      @if (tabService.isChatQuestion(message)) {
        <!-- -------- -->
        <!-- Question -->
        <!-- -------- -->
        <div class="pb-4 pt-8 text-right" data-testid="chat-question">
          @for (content of message?.content; track content.text) {
            <markdown class="chat-question inline-block max-w-[90%]">{{ content.text }}</markdown>
          }
        </div>
        @if (currentThread()?.isPolling && isLastMessage(message)) {
          <div class="relative min-h-10 pb-4 pl-10">
            <app-chat-icon class="absolute left-0 top-0" [spinning]="true" />
            <markdown class="animate-blink">{{ 'chatMessages.loading' | transloco }}</markdown>
          </div>
        }
      } @else if (tabService.isInfoMessage(message) && message.id === infoMessage()?.id) {
        <!-- ------------ -->
        <!-- Info Message -->
        <!-- ------------ -->
        <div class="relative pb-4 pl-10" data-testid="info-message">
          <app-chat-icon class="absolute left-0 top-0" [spinning]="!!(currentThread()?.isPolling && isLastMessage(message))" />
          @for (content of message?.content; track content.text) {
            <markdown class="animate-blink">{{ content.text }}</markdown>
          }
        </div>
      } @else if (tabService.isChatAnswer(message)) {
        <!-- ---------- -->
        <!-- Bot Answer -->
        <!-- ---------- -->
        <div class="relative pb-4 pl-10" data-testid="chat-answer">
          <app-chat-icon class="absolute left-0 top-0" [spinning]="!!(currentThread()?.isPolling && isLastMessage(message))" />
          @if (hasRecallSource(message?.content)) {
            <div class="mb-4 rounded-lg border border-zinc-100 bg-gray-50 p-4">
              <h3 class="mb-2 font-bold text-gray-900">
                {{ 'chatMessages.alert.title' | transloco }}
              </h3>
              <div class="flex gap-3">
                <i class="pi pi-exclamation-triangle mt-1 flex-shrink-0 text-red-500"></i>
                <p class="text-gray-700">
                  {{ 'chatMessages.alert.content' | transloco }}
                </p>
              </div>
            </div>
          }

          @for (content of message?.content; track content.provider + $index + content.document?.previewText) {
            @if (messageService.getMessageType(content) === 'text') {
              <app-message-content-text [content]="content" class="mb-4 block" />
            }

            @if (isLastMessage(message)) {
              <app-message-content-intent-suggestions [content]="content" [tabId]="currentThread()?._id" />
            }
          }

          @if (containsSmartSearchMessage(message?.content)) {
            <div class="rounded-lg border border-primary-500 p-4">
              <h3 class="mb-5 text-base font-semibold">{{ 'chatMessages.smartSearch.headline' | transloco }}</h3>

              <app-smart-search
                [content]="message?.content"
                [tabId]="currentThread()?._id"
                [maxVisibleItems]="3"
                [showCitedTag]="true"
                [vehicle]="vehicle()"
                class="mb-4 block" />

              <div class="mt-4 flex justify-end">
                <app-smart-search-modal-button
                  [content]="message?.content"
                  [tabId]="currentThread()?._id"
                  [messageIndex]="$index"
                  [disabled]="getNoOfSmartSearchResults(message?.content) < 3" />
              </div>
            </div>
          }

          @if (isLastMessage(message)) {
            <app-message-voice-toggle />
          }

          @if (message.type === 'end') {
            <app-message-feedback-links [message]="message" [threadId]="currentThread()?._id || ''" class="mt-4 block" />
          }
        </div>
      }
    </div>
  }
}
